import React, { useContext } from 'react'
import { ThemeContext } from 'styled-components'
import { LoadingIcon } from '@chegg-ui/theme'
import { LOADING_DOTS } from './testIds'
import { LoadingDotsProps } from './types'
import * as Styled from './styled'

export const LoadingDots: React.FC<LoadingDotsProps> = ({
  className = '',
  color,
  size = 'large',
  verticalPadding,
  message = '',
  'data-test': testId = LOADING_DOTS,
}) => {
  const themeContext = useContext(ThemeContext)
  return (
    <Styled.LoadingContainer
      className={className}
      verticalPadding={verticalPadding}
      data-test={testId}
      aria-live="assertive"
    >
      <LoadingIcon svgColor={color ?? themeContext.Colors.primaryColor} size={size} />
      {message ? <Styled.LoadingText>{message}</Styled.LoadingText> : null}
    </Styled.LoadingContainer>
  )
}
